<script>
    import { goto } from '@sveltech/routify'
</script>

<div class="h-screen w-screen flex items-center">
    <div
        class="container flex flex-col md:flex-row items-center justify-start px-5 text-gray-700">
        <div class="max-w-md flex-column justify-center items-center">
            <div class="text-5xl font-dark font-bold">404</div>
            <p class="text-2xl md:text-3xl font-light leading-normal">
                This page does not exist.
            </p>
            <p class="mb-8">Navigate back to the login page.</p>

            <button
                on:click={$goto('/')}
                class="px-4 inline py-2 text-sm font-medium leading-5 shadow text-white transition-colors duration-150 border border-transparent rounded-lg focus:outline-none focus:shadow-outline-blue bg-blue-600 active:bg-blue-600 hover:bg-blue-700">back
                to homepage</button>
        </div>
    </div>
</div>
